
export interface RecordColumn {
  label: string;
  width?: string;
  align?: 'left' | 'right';
  mono?: boolean;
  badge?: boolean;
}

export type RecordRow =
  string[] | { c: string[]; head?: boolean; bold?: boolean; emphasis?: boolean };

export interface RecordSet {
  crumb: string;
  title: string;
  subtitle: string;
  chips: string[];
  cols: RecordColumn[];
  rows: RecordRow[];
  total?: string[];
}

const R = 'right' as const;






export const RECORD_SETS: Record<string, RecordSet> = {} as Record<string, RecordSet>;





export const REPORT_GROUPS: Array<{ title: string; items: string[] }> = [
  {
    title: 'Financial',
    items: [
      'Day Book',
      'Cash Book',
      'Bank Book',
      'General Ledger',
      'Trial Balance',
      'Profit & Loss',
      'Balance Sheet',
      'Cash Flow (indirect)',
      'Journal Register',
    ],
  },
  {
    title: 'Party',
    items: [
      'Supplier Ledger',
      'Customer Ledger',
      'AR Ageing',
      'AP Ageing',
      'Party Balance Summary',
      'Overdue & Follow-up',
    ],
  },
  {
    title: 'Purchase & Import',
    items: [
      'Purchase Register',
      'Import Costing Sheet',
      'Landed Cost Analysis',
      'Purchase Return Register',
      'Country / Port-wise Volume',
      'FX Gain–Loss on Imports',
    ],
  },
  {
    title: 'Inventory',
    items: [
      'Stock Ledger',
      'Stock Summary (warehouse-wise)',
      'Valuation Report',
      'Batch & Expiry',
      'Reorder Report',
      'Slow & Non-moving',
      'Movement Analysis',
      'Tally Variance',
    ],
  },
  {
    title: 'Sales',
    items: [
      'Sales Register',
      'Sales by Product',
      'Sales by Customer',
      'Sales by Zone',
      'Sales by Salesperson',
      'Gross Margin Analysis',
      'Sale Return Register',
      'Target vs Achievement',
    ],
  },
  {
    title: 'Commission',
    items: [
      'Salesperson Commission Statement',
      'Accrued vs Paid',
      'Slab Achievement',
      'Zone-wise Payout',
    ],
  },
  {
    title: 'Brokerage',
    items: [
      'Deal Register',
      'Deal Pipeline Ageing',
      'Pending Settlement',
      'Commission Receivable Ageing',
      'Supplier Performance',
      'Buyer Performance',
      'Import Deal Tracker',
      'Sub-agent Statement',
    ],
  },
  {
    title: 'Management',
    items: [
      'Zone-wise Profitability',
      'Product Profitability',
      'Cost-Center P&L',
      'Budget vs Actual',
      'KPI Dashboard',
    ],
  },
  {
    title: 'Compliance',
    items: [
      'Sales Tax Register – Output',
      'Sales Tax Register – Input',
      'WHT Register',
      'Audit Trail Report',
    ],
  },
];
